
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    priceData: {
      type: Object,
      default: () => { return {} }
    }
  }
})
